import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { advisorVerify } from "../../lib/api";
import { NoIndex } from "../../components/Seo";

export default function AdvisorVerify() {
  const { token } = useParams();
  const [state, setState] = useState("checking");
  useEffect(() => {
    advisorVerify(token).then(() => setState("ok")).catch(() => setState("bad"));
  }, [token]);
  return (
    <div className="min-h-screen grid place-items-center px-6" data-testid="advisor-verify-page">
      <NoIndex title="Verify email" />
      <div className="max-w-sm text-center">
        <h1 className="font-serif text-2xl font-medium">
          {state === "checking" ? "Confirming…" : state === "ok" ? "Email confirmed" : "This link isn't valid anymore"}
        </h1>
        <p className="mt-2 text-sm text-muted-foreground">
          {state === "ok" ? "Your advisor account is verified. You can close this tab or head to your dashboard." : state === "bad" ? "Request a fresh confirmation email from the dashboard banner." : ""}
        </p>
        <Link to="/advisor" data-testid="advisor-verify-continue" className="mt-6 inline-block rounded-full bg-primary text-primary-foreground px-5 py-2.5 text-sm font-medium">Go to the advisor portal</Link>
      </div>
    </div>
  );
}
